<template>
  <van-overlay show class-name="share-history overflow-y-auto" z-index="1000">
    <template v-if="!isLoad">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </template>
    <template v-else>
      <template v-if="!historyList.length">
        <div class="empty-box text-center" style="padding-top: 150px">
          <img src="~@/assets/img/svg/share/empty.png" alt="" class="max-w-full" />
          <div class="mt-2">
            <span>暂无数据</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="container-box">
          <div class="shadow-box relative py-4 flex px-6 text-theme-black-450">
            <div class="flex-1">
              <div>
                <div>
                  <span class="text-small">分享总人数(人)</span>
                </div>
                <div class="text-large-x text-theme-black-850">{{ historyList.length }}</div>
              </div>
            </div>
            <template v-if="hadShare">
              <div class="line"></div>
              <div class="flex-1">
                <div class="ml-4">
                  <div>
                    <span class="text-small">分享领取金额合计(元)</span>
                  </div>
                  <div class="text-large-x text-theme-black-850">{{ totalAmount }}</div>
                </div>
              </div>
            </template>
          </div>
          <div class="shadow-box p-4 mt-4">
            <ul>
              <li v-for="(item, index) in historyList" :key="index" class="history-item-wrap">
                <share-history-item :item="item" />
              </li>
            </ul>
          </div>
        </div>
      </template>
    </template>
  </van-overlay>
</template>

<script>
import ShareHistoryItem from '@/components/overlay/c/ShareHistoryItem'
import { busGetters, getShareAnswer } from 'dygc'

export default {
  name: 'OverlayShareHistory',
  components: { ShareHistoryItem },
  props: {
    accountUserId: {
      type: String,
      default: ''
    },
    accountUserFingerprint: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    },
    answerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      historyList: [],
      total: 0,
      loading: false,
      isLoad: false
    }
  },
  created() {
    this.getList()
  },
  computed: {
    finished() {
      return this.historyList.length === this.total
    },
    totalAmount() {
      return this.historyList.reduce((res, item) => {
        if (item.amount) {
          return Number(Number(res) + item.amount).toFixed(2)
        }
        return res
      }, 0)
    },
    ...busGetters(['hadShare'])
  },
  methods: {
    getList() {
      getShareAnswer(this.answerId).then(res => {
        this.historyList = res.data
        this.isLoad = true
      })
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
